module.exports = __webpack_public_path__ + "static/media/action_starthand.8de2cac8.mp3";